module.exports = __webpack_public_path__ + "static/media/jquery.1bcea443.png";